// *** REACT components
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";
// *** CONTEXT
import UsuarioProvider from 'config/context/UsuarioProvider'
// *** STYLES
import "assets/scss/material-kit-pro-react.scss?v=1.9.0";
// *** Callback
import KhipuNotify from 'pages/Callback/KhipuNotify.js'
import IndexHome from 'pages/Home/IndexHome.jsx'
import quienesSomos from 'pages/Menu/quienesSomos.jsx'
import atencionEnLinea from 'pages/Menu/atencionEnLinea.jsx'
import productos from 'pages/Menu/productos.jsx'

// import  FlujoFAO   from 'pages/Compra/FlujoFAO'
import  ConfirmarPago   from 'pages/Compra/workflowCompra/ConfirmarPago/confirmarPago'
import FlujoFEA from 'pages/Compra/FlujoFEA'
import FlujoFES from 'pages/Compra/FlujoFES'
import DescargaFes from 'pages/Descarga/FES'
import contactanos from 'pages/Menu/contactanos'


var hist = createBrowserHistory();

ReactDOM.render(
    <UsuarioProvider>
        <Router history={hist}>
          <Switch>
            <Route path="/callback/KhipuNotify/:api_version?/:notification_token?" component={KhipuNotify}  />
            {/*<Route exact path="/compra/firma-online" component={FlujoFAO}  />*/}
            <Route exact path="/compra/firma-simple" component={FlujoFES}  />
            <Route exact path="/compra/firma-token" component={FlujoFEA}  />
            <Route exact path="/compra/firma-online" component={IndexHome}  />
            <Route exact path="/descargar-simple" component={DescargaFes}  />
            <Route exact path="/compra/confirmar-pago" component={ConfirmarPago}  />
            <Route exact path="/menu/quienesSomos" component={quienesSomos}  />
            <Route exact path="/menu/atencionEnLinea" component={atencionEnLinea}  />
            <Route exact path="/menu/productos" component={productos}  />
            <Route exact path="/menu/contactanos" component={contactanos}  />
            <Route path="/" component={IndexHome}/>
          </Switch>
        </Router>
    </UsuarioProvider>
,
  document.getElementById("root")
);
